export const CONTAINER = {
	PROJECT: 'PROJECT',
	SECTION: 'SECTION',
	COLLECTION: 'COLLECTION',
} as const;

export const VIEW_NAME_MAX_LENGTH = 100;
